import { create } from 'zustand';

import type { IUser } from '@typings/IUser';
import { createApiClient, type ApiRequestFn } from '@lib/api/api';

interface IClientContextState {
    user: IUser | null;
    uuid: string;

    apiRequest: ApiRequestFn;
}

interface IClientContextAction {
    setSession: (uuid: string, user: IUser | null, apiRequest: ApiRequestFn) => void;
}

export const useClientContext = create<IClientContextState & IClientContextAction>(set => ({
    user: null,
    uuid: '',

    apiRequest: createApiClient(undefined),
    setSession: (uuid, user, apiRequest) => void set({ uuid, user, apiRequest }),
}));
